import React, { useEffect, useState } from 'react'
import './AnnouncementBar.css'

const announcements = [
    'Welcome to our website!',
    'Check out our latest products.',
    'Join our community and get exclusive offers.',
]

const announcementScrollTime = 15000 // ms. must be same as announcement-content animation time in css.

const AnnouncementBar = () => {
    const [ currentItemIndex, setCurrentItemIndex ] = useState( 0 )

    useEffect( () => {
        const interval = setInterval( () => {
            setCurrentItemIndex( ( prevIndex ) => ( prevIndex + 1 ) % announcements.length )
        }, announcementScrollTime )

        return () => {
            clearInterval( interval )
        }
    }, [] )

    return (
        <div className="announcement-bar">
            <div className="announcement-content">
                { announcements.map( ( announcement, index ) => (
                    <div
                        key={ index }
                        className={ `announcement-item ${ index === currentItemIndex ? 'active' : '' }` }
                    >
                        <span>{ announcement }</span>
                    </div>
                ) ) }
            </div>
        </div>
    )
}

export default AnnouncementBar
